import React from 'react';

const Connecticut = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Connecticut Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Property Condition Disclosure Report: Mandatory unless the seller opts
          out (with penalties).
        </li>
        <li>Attorney Review: Strongly recommended for both parties.</li>
      </ol>
      <li>
        <span
          className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
          onClick={() => {
            window.open(
              'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
              '_blank'
            );
          }}
        >
          Lead-Based Paint Disclosure{' '}
        </span>{' '}
        – Only for residences that were built before 1978. This information
        should be available at the County’s Revenue Office.
      </li>
      <li>
        <span
          className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
          onClick={() => {
            window.open(
              'https://eforms.com/images/2018/08/Connecticut-Residential-Property-Condition-Report.pdf',
              '_blank'
            );
          }}
        >
          Residential Property Condition Report{' '}
        </span>{' '}
        – Sellers must complete this form and present it to potential buyers
        prior to any binder or contract.
      </li>
    </div>
  );
};

export default Connecticut;
